import React, { Component } from "react";
import {
  NormalButtonBackend,
  NormalCheckbox,
  NormalInput,
  NormalSelect,
} from "component/common";
import { withTranslation } from "react-i18next";
import {
  NewItemRanges,
  ItemBrands,
  rangelists,
  updateCommon,
} from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Toast } from "service/toast";

export default class EditvoucherClass extends Component {
  state = {
    itemId: null,
    desc: null,
    brandlist: [],
    brand: null,
    checked: true,
  };

  componentDidMount = () => {
    let { itemId } = this.state;
    itemId = window.location.pathname.split("/")[4];
    this.setState({ itemId });
    this.Listofbrans({});
    this.Listofrange(itemId);
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  /* List Of range */
  Listofrange = async (code) => {
    let { desc, brand, checked, temp } = this.state;
    await this.props.rangelists().then((res) => {
      let objIndex = res.findIndex((obj) => obj.itmCode == code);
      temp = res[objIndex];
      this.setState({
        temp,
      });
      desc = temp.itmDesc;
      brand = temp.itmBrand;
      checked = temp.itmStatus;
      this.setState({
        desc,
        brand,
        checked,
      });
    });
  };

  /* List Function */
  Listofbrans = async () => {
    await this.props.ItemBrands().then((res) => {
      let { brandlist } = this.state;
      for (let key of res) {
        if (key.voucherBrand) {
          brandlist.push({ value: key.itmCode, label: key.itmDesc });
        }
      }
      this.setState({
        brandlist,
        is_loading: false,
      });
    });
  };

  /* Code matching */
  temp = ({ target: { value, name } }) => {
    let { code, desc, brand, checked } = this.state;
    if (name == "code") {
      code = value;
      this.setState({ code });
    }
    if (name == "desc") {
      desc = value;
      this.setState({ desc });
    }
    if (name == "brand") {
      brand = value;
      this.setState({ brand });
    }
    if (name == "checked") {
      checked = value;
      this.setState({ checked });
    }
  };

  /* Update The data Function */
  Addnewbrand = async () => {
    let { itemId, desc, brand, checked } = this.state;
    let editbrand = {
      itmCode: itemId,
      itmDesc: desc,
      itmStatus: checked,
      itmSeq: null,
      itmBrand: brand,
      itmDept: null,
      isproduct: false,
      picPath: null,
      prepaidForProduct: false,
      prepaidForService: false,
      prepaidForAll: false,
      isservice: false,
      isvoucher: true,
      isprepaid: false,
      iscompound: false,
    };
    await this.props
      .updateCommon(
        `ItemRanges/update?where=%7B%22itmCode%22%3A%20%22${this.state.itemId}%22%7D
    `,
        editbrand
      )
      .then((data) => {
        Toast({
          type: "success",
          message: "Successfully updated",
        });
        this.props.history.push(
          `/admin/backend/itemclassification/range/classvoucher`
        );
      })
      .catch((e) => console.log(e));
  };

  render() {
    let { t } = this.props;
    let { itemId, desc, checked, brand, brandlist } = this.state;
    return (
      <div className="bg-white">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <h5 className="mt-4 mb-0 label-head text-center text-md-left">
                {t("Voucher Range")}
              </h5>
            </div>
          </div>
          <div className="row mt-1 col-12">
            <div className="col-12 col-md-6 mt-3">
              <span>Code</span>
              <span style={{ color: "red" }}>*</span>
              <NormalInput
                value={itemId}
                name="code"
                onChange={this.temp}
                disabled={true}
              />
            </div>
            <div className="col-12 col-md-6 mt-3">
              <span>Description</span>
              <span style={{ color: "red" }}>*</span>
              <NormalInput value={desc} name="desc" onChange={this.temp} />
            </div>
          </div>
          <div className="row mt-1 col-12">
            <div className="col-12 col-md-6 mt-3">
              <span>Brand</span>
              <span style={{ color: "red" }}>*</span>
              <NormalSelect
                options={brandlist}
                value={brand}
                onChange={this.temp}
                name="brand"
              />
            </div>
            <div className="col-12 col-md-6 mt-3">
              <div className="d-flex mt-3 mt-md-4">
                <NormalCheckbox
                  checked={checked}
                  name="checked"
                  onChange={this.temp}
                />
                <p>{t("Active")}</p>
              </div>
            </div>
          </div>

          <div className="mt-3 col-12 col-md-2">
            <NormalButtonBackend
              mainbg={true}
              label={"Update"}
              onClick={() => this.Addnewbrand()}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      NewItemRanges,
      ItemBrands,
      updateCommon,
      rangelists,
    },
    dispatch
  );
};

export const Editvoucher = withTranslation()(
  connect(null, mapDispatchToProps)(EditvoucherClass)
);
